"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResponsivePropValue = void 0;
var _responsivePropNames = require("./responsivePropNames");
const getResponsivePropValue = (props, propName, fromBreakpoint) => {
  if (!fromBreakpoint) return props[propName];
  const propNameList = (0, _responsivePropNames.responsivePropNames)(propName);
  return propNameList.slice(0, propNameList.indexOf(`${propName}From${fromBreakpoint}`) + 1).reduce((currentValue, breakpoint) => {
    var _props$breakpoint;
    return (_props$breakpoint = props[breakpoint]) !== null && _props$breakpoint !== void 0 ? _props$breakpoint : currentValue;
  }, props[propName]);
};
exports.getResponsivePropValue = getResponsivePropValue;